import { quantityOrderedStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsQuantityOrdered";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

Object.assign(quantityOrderedStyles, {
    quantityOrdered: {
        sizeVariant: "small",
        labelProps: {
            size: TYPOGRAPHY.size.smallest,
            css: css`
                width: auto;
            `,
        },
        cssOverrides: {
            formField: css`
                width: 45px;
                margin-right: 1em;
            `,
        },
    },
});
